import React, { useState } from 'react';
import { Typography, Box, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';

const DateDuration = ({ duration, color }) => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: 2,
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Start"
            value={startDate}
            onChange={(newValue) => setStartDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
            InputAdornmentProps={{ position: 'start' }}
            InputProps={{ startAdornment: <CalendarTodayIcon /> }}
            sx={{ width: '45%', color: { color } }}
          />
          <DatePicker
            label="End"
            value={endDate}
            onChange={(newValue) => setEndDate(newValue)}
            renderInput={(params) => <TextField {...params} />}
            InputAdornmentProps={{ position: 'start' }}
            InputProps={{ startAdornment: <CalendarTodayIcon /> }}
            sx={{ width: '45%', color: { color } }}
          />
        </LocalizationProvider>
      </Box>
      <Typography
        align="center"
        color="textSecondary"
        sx={{ marginTop: 1, color: { color } }}
      >
        {duration}
      </Typography>
    </Box>
  );
};
export default DateDuration;
